import * as model from '@/model';
import { FlowHttpRequestOptions, mixHeadersOptions, pick } from '@snfe/flow-yapi-helpers';
import http from '../http';

/**
 * @desc id=1521683, catid=258399, projectId=41427, created=2025-05-30 15:38:29, last-modified=2025-06-24 15:28:46
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/comment/page)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521683)
 */
export function postCommWebApiModelPostCommentPage(
  params: model.commWebApi.IPostCommWebApiModelPostCommentPageParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostCommentPageResponse>('/commWebApi/model/post/comment/page', {
    params: pick(params, ['pageNum']),
    data: pick(params, ['pageNum', 'pageSize', 'searchId', 'postId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521719, catid=258399, projectId=41427, created=2025-05-30 17:15:02, last-modified=2025-06-24 15:10:59
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/currentUser/page)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521719)
 */
export function postCommWebApiModelPostCurrentUserPage(
  params: model.commWebApi.IPostCommWebApiModelPostCurrentUserPageParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostCurrentUserPageResponse>('/commWebApi/model/post/currentUser/page', {
    data: pick(params, ['pageNum', 'pageSize', 'search', 'status']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521620, catid=258399, projectId=41427, created=2025-05-29 16:41:10, last-modified=2025-06-10 17:19:57
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/page)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521620)
 */
export function postCommWebApiModelPostPage(
  params: model.commWebApi.IPostCommWebApiModelPostPageParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostPageResponse>('/commWebApi/model/post/page', {
    data: pick(params, ['pageNum', 'pageSize', 'search', 'domainTag', 'modelTag', 'sortord']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1522652, catid=258399, projectId=41427, created=2025-06-11 17:17:52, last-modified=2025-06-11 17:21:21
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/upload/img)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1522652)
 */
export function postCommWebApiModelPostUploadImg(
  params: model.commWebApi.IPostCommWebApiModelPostUploadImgParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostUploadImgResponse>('/commWebApi/model/post/upload/img', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'multipart/form-data' }),
  });
}

/**
 * @desc id=1521695, catid=258399, projectId=41427, created=2025-05-30 16:16:50, last-modified=2025-06-10 19:47:37
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/feedback)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521695)
 */
export function postCommWebApiModelPostFeedback(
  params: model.commWebApi.IPostCommWebApiModelPostFeedbackParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostFeedbackResponse>('/commWebApi/model/post/feedback', {
    params: pick(params, ['pageNum']),
    data: pick(params, ['id', 'userFeedback']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521645, catid=258399, projectId=41427, created=2025-05-29 18:34:52, last-modified=2025-05-29 18:49:27
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/creator/recommend)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521645)
 */
export function postCommWebApiModelPostCreatorRecommend(
  params: model.commWebApi.IPostCommWebApiModelPostCreatorRecommendParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostCreatorRecommendResponse>('/commWebApi/model/post/creator/recommend', {
    params: pick(params, ['pageNum']),
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521701, catid=258399, projectId=41427, created=2025-05-30 16:57:30, last-modified=2025-05-30 17:01:23
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/comment/write)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521701)
 */
export function postCommWebApiModelPostCommentWrite(
  params: model.commWebApi.IPostCommWebApiModelPostCommentWriteParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostCommentWriteResponse>('/commWebApi/model/post/comment/write', {
    params: pick(params, ['pageNum']),
    data: pick(params, ['postId', 'content']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521714, catid=258399, projectId=41427, created=2025-05-30 17:01:26, last-modified=2025-06-10 19:47:30
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/comment/feedback)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521714)
 */
export function postCommWebApiModelPostCommentFeedback(
  params: model.commWebApi.IPostCommWebApiModelPostCommentFeedbackParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostCommentFeedbackResponse>('/commWebApi/model/post/comment/feedback', {
    params: pick(params, ['pageNum']),
    data: pick(params, ['id', 'userFeedback']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521682, catid=258399, projectId=41427, created=2025-05-30 14:17:27, last-modified=2025-06-13 16:23:12
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521682)
 */
export function postCommWebApiModelPostDetail(
  params: model.commWebApi.IPostCommWebApiModelPostDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostDetailResponse>('/commWebApi/model/post/detail', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521652, catid=258399, projectId=41427, created=2025-05-29 19:19:46, last-modified=2025-06-26 17:17:12
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/post/save)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521652)
 */
export function postCommWebApiModelPostSave(
  params: model.commWebApi.IPostCommWebApiModelPostSaveParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelPostSaveResponse>('/commWebApi/model/post/save', {
    data: pick(params, [
      'id',
      'saveType',
      'title',
      'content',
      'qualityScore',
      'performanceScore',
      'costEffectivenessScore',
      'domainTags',
      'modelTags',
    ]),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1523094, catid=258399, projectId=41427, created=2025-06-16 11:04:42, last-modified=2025-06-24 14:27:34
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/notify/page)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1523094)
 */
export function postCommWebApiNotifyPage(params: model.commWebApi.IPostCommWebApiNotifyPageParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiNotifyPageResponse>('/commWebApi/notify/page', {
    data: pick(params, ['pageNum', 'pageSize', 'module']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519910, catid=258133, projectId=41427, created=2025-05-08 16:55:18, last-modified=2025-05-15 10:04:38
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/update-profile)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519910)
 */
export function postCommWebApiUserUpdateProfile(
  params: model.commWebApi.IPostCommWebApiUserUpdateProfileParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserUpdateProfileResponse>('/commWebApi/user/update-profile', {
    data: pick(params, [
      'userId',
      'newName',
      'avatarUrl',
      'mobileNumber',
      'sex',
      'age',
      'location',
      'job',
      'email',
      'personalWebsite',
      'industry',
      'role',
      'graduationSchool',
      'organization',
      'userType',
      'education',
      'tag',
      'introduction',
    ]),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519916, catid=258133, projectId=41427, created=2025-05-08 17:00:18, last-modified=2025-05-20 09:57:30
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/upload)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519916)
 */
export function postCommWebApiUserUpload(params: model.commWebApi.IPostCommWebApiUserUploadParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiUserUploadResponse>('/commWebApi/user/upload', {
    data: pick(params, ['file']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520328, catid=258133, projectId=41427, created=2025-05-14 11:34:05, last-modified=2025-05-15 14:10:03
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/delete-tag)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520328)
 */
export function postCommWebApiUserDeleteTag(
  params: model.commWebApi.IPostCommWebApiUserDeleteTagParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserDeleteTagResponse>('/commWebApi/user/delete-tag', {
    data: pick(params, ['userId', 'tag']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519906, catid=258133, projectId=41427, created=2025-05-08 16:47:55, last-modified=2025-05-09 14:47:51
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/unfollow)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519906)
 */
export function postCommWebApiUserUnfollow(
  params: model.commWebApi.IPostCommWebApiUserUnfollowParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserUnfollowResponse>('/commWebApi/user/unfollow', {
    data: pick(params, ['followerId', 'followedId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519875, catid=258133, projectId=41427, created=2025-05-08 16:28:48, last-modified=2025-05-09 14:47:21
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/check-following)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519875)
 */
export function postCommWebApiUserCheckFollowing(
  params: model.commWebApi.IPostCommWebApiUserCheckFollowingParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserCheckFollowingResponse>('/commWebApi/user/check-following', {
    data: pick(params, ['followerId', 'followedId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521584, catid=258133, projectId=41427, created=2025-05-29 13:09:01, last-modified=2025-06-13 14:15:59
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/audit/updateTip)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521584)
 */
export function postCommWebApiAuditUpdateTip(
  params: model.commWebApi.IPostCommWebApiAuditUpdateTipParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiAuditUpdateTipResponse>('/commWebApi/audit/updateTip', {
    data: pick(params, ['id', 'tip', 'auditType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519882, catid=258133, projectId=41427, created=2025-05-08 16:35:36, last-modified=2025-05-09 14:47:41
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/follow)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519882)
 */
export function postCommWebApiUserFollow(params: model.commWebApi.IPostCommWebApiUserFollowParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiUserFollowResponse>('/commWebApi/user/follow', {
    data: pick(params, ['followerId', 'followedId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1522924, catid=258133, projectId=41427, created=2025-06-13 14:30:12, last-modified=2025-06-13 14:31:29
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/audit/auditImageResult)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1522924)
 */
export function postCommWebApiAuditAuditImageResult(options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiAuditAuditImageResultResponse>('/commWebApi/audit/auditImageResult', {
    ...mixHeadersOptions(options, { 'Content-Type': 'application/x-www-form-urlencoded' }),
  });
}

/**
 * @desc 文字示例以下是。说明。 图片只有审核状态 单条的 暂不记录不通过原因前端直接提示审核失败
 *示例返回数据
 *审核通过
 *json
 *
 *
 *{
 *&#34;code&#34;: 200,
 *&#34;message&#34;: &#34;审核通过&#34;,
 *&#34;data&#34;: {
 *  &#34;userId&#34;: 143,
 *  &#34;avatarAuditStatus&#34;: 2,
 *  &#34;auditType&#34;: 1,
 *  &#34;pendingAvatarUrl&#34;: &#34;http://example.com/avatar.jpg&#34;
 *}
 *}
 *
 *审核拒绝
 *json
 *
 *
 *{
 *&#34;code&#34;: 400,
 *&#34;message&#34;: &#34;审核未通过&#34;,
 *&#34;data&#34;: {
 *  &#34;userId&#34;: 143,
 *  &#34;avatarAuditStatus&#34;: 3,
 *  &#34;auditType&#34;: 1,
 *  &#34;pendingAvatarUrl&#34;: &#34;http://example.com/avatar.jpg&#34;,
 *  &#34;rejectedFields&#34;: {
 *    &#34;organization&#34;: [
 *      {
 *        &#34;code&#34;: 22,
 *        &#34;subCode&#34;: 193,
 *        &#34;subDesc&#34;: &#34;低俗性感&#34;,
 *        &#34;desc&#34;: &#34;涉黄&#34;
 *      },
 *      {
 *        &#34;code&#34;: 25,
 *        &#34;subCode&#34;: 81,
 *        &#34;subDesc&#34;: &#34;新闻&#34;,
 *        &#34;desc&#34;: &#34;新闻&#34;
 *      }
 *    ],
 *    &#34;tag_30ec1d8a&#34;: [
 *      {
 *        &#34;code&#34;: 190,
 *        &#34;subCode&#34;: 191,
 *        &#34;subDesc&#34;: &#34;不良价值观&#34;,
 *        &#34;desc&#34;: &#34;不良导向&#34;
 *      }
 *    ]
 *  }
 *}
 *}
 * @desc id=1521575, catid=258133, projectId=41427, created=2025-05-29 13:07:55, last-modified=2025-06-13 14:31:04
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/audit/auditResult)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521575)
 */
export function postCommWebApiAuditAuditResult(
  params: model.commWebApi.IPostCommWebApiAuditAuditResultParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiAuditAuditResultResponse>('/commWebApi/audit/auditResult', {
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519839, catid=258133, projectId=41427, created=2025-05-08 15:52:41, last-modified=2025-05-09 14:46:08
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/queryTestSets)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519839)
 */
export function postCommWebApiUserQueryTestSets(
  params: model.commWebApi.IPostCommWebApiUserQueryTestSetsParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserQueryTestSetsResponse>('/commWebApi/user/queryTestSets', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519844, catid=258133, projectId=41427, created=2025-05-08 16:07:50, last-modified=2025-05-09 14:47:08
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/queryTestSetsDetail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519844)
 */
export function postCommWebApiUserQueryTestSetsDetail(
  params: model.commWebApi.IPostCommWebApiUserQueryTestSetsDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserQueryTestSetsDetailResponse>('/commWebApi/user/queryTestSetsDetail', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519908, catid=258133, projectId=41427, created=2025-05-08 16:50:32, last-modified=2025-05-13 17:30:48
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/get-profile)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519908)
 */
export function postCommWebApiUserGetProfile(
  params: model.commWebApi.IPostCommWebApiUserGetProfileParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserGetProfileResponse>('/commWebApi/user/get-profile', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519878, catid=258133, projectId=41427, created=2025-05-08 16:32:54, last-modified=2025-06-30 15:16:10
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/follow-list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519878)
 */
export function postCommWebApiUserFollowList(
  params: model.commWebApi.IPostCommWebApiUserFollowListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserFollowListResponse>('/commWebApi/user/follow-list', {
    data: pick(params, ['userId', 'page', 'pageSize']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504672, catid=256704, projectId=41427, created=2025-01-13 14:22:42, last-modified=2025-04-28 16:16:33
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/evaluation/page)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504672)
 */
export function postCommWebApiEvaluationPage(
  params: model.commWebApi.IPostCommWebApiEvaluationPageParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiEvaluationPageResponse>('/commWebApi/evaluation/page', {
    params: pick(params, ['pageNum']),
    data: pick(params, ['pageNum', 'pageSize', 'search', 'modality', 'source', 'type', 'openStatus', 'sortord']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504681, catid=256704, projectId=41427, created=2025-01-13 14:31:33, last-modified=2025-04-28 16:17:43
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/evaluation/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504681)
 */
export function postCommWebApiEvaluationDetail(
  params: model.commWebApi.IPostCommWebApiEvaluationDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiEvaluationDetailResponse>('/commWebApi/evaluation/detail', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504670, catid=256704, projectId=41427, created=2025-01-13 14:13:18, last-modified=2025-04-28 16:14:31
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/evaluation/home)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504670)
 */
export function postCommWebApiEvaluationHome(
  params: model.commWebApi.IPostCommWebApiEvaluationHomeParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiEvaluationHomeResponse>('/commWebApi/evaluation/home', {
    data: pick(params, ['source']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504698, catid=256715, projectId=41427, created=2025-01-13 15:16:02, last-modified=2025-02-13 17:04:46
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/top)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504698)
 */
export function postCommWebApiModelRankTop(
  params: model.commWebApi.IPostCommWebApiModelRankTopParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankTopResponse>('/commWebApi/model/rank/top', {
    data: pick(params, ['modality', 'modelType', 'rankMonth', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504699, catid=256715, projectId=41427, created=2025-01-13 15:18:33, last-modified=2025-02-14 17:00:03
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/dataList)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504699)
 */
export function postCommWebApiModelRankDataList(
  params: model.commWebApi.IPostCommWebApiModelRankDataListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankDataListResponse>('/commWebApi/model/rank/dataList', {
    data: pick(params, ['modality', 'modelType', 'rankMonth', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504935, catid=256715, projectId=41427, created=2025-01-15 11:29:42, last-modified=2025-01-15 16:24:03
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/listDate)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504935)
 */
export function postCommWebApiModelRankListDate(
  params: model.commWebApi.IPostCommWebApiModelRankListDateParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankListDateResponse>('/commWebApi/model/rank/listDate', {
    data: pick(params, ['modality', 'modelType', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504708, catid=256715, projectId=41427, created=2025-01-13 15:21:06, last-modified=2025-01-23 15:44:20
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504708)
 */
export function postCommWebApiModelRankList(
  params: model.commWebApi.IPostCommWebApiModelRankListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankListResponse>('/commWebApi/model/rank/list', {
    data: pick(params, ['modality', 'modelType', 'rankMonth', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504715, catid=256715, projectId=41427, created=2025-01-13 15:22:13, last-modified=2025-02-14 17:01:35
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504715)
 */
export function postCommWebApiModelRankDetail(
  params: model.commWebApi.IPostCommWebApiModelRankDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankDetailResponse>('/commWebApi/model/rank/detail', {
    data: pick(params, ['modelRankId', 'rankType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504706, catid=256715, projectId=41427, created=2025-01-13 15:19:59, last-modified=2025-02-18 14:37:51
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/rank/config/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504706)
 */
export function postCommWebApiModelRankConfigDetail(
  params: model.commWebApi.IPostCommWebApiModelRankConfigDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelRankConfigDetailResponse>('/commWebApi/model/rank/config/detail', {
    data: pick(params, ['modality', 'modelType', 'rankType', 'rankMonth']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504724, catid=256718, projectId=41427, created=2025-01-13 15:23:56, last-modified=2025-01-27 11:00:54
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/person/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504724)
 */
export function postCommWebApiPersonList(params: model.commWebApi.IPostCommWebApiPersonListParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiPersonListResponse>('/commWebApi/person/list', {
    data: pick(params, ['onlyHomeShow', 'type']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504728, catid=256718, projectId=41427, created=2025-01-13 15:25:07, last-modified=2025-04-28 16:23:21
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/person/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504728)
 */
export function postCommWebApiPersonDetail(
  params: model.commWebApi.IPostCommWebApiPersonDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiPersonDetailResponse>('/commWebApi/person/detail', {
    data: pick(params, ['id']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1504730, catid=256720, projectId=41427, created=2025-01-13 15:26:20, last-modified=2025-01-20 14:34:37
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/organization/list)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1504730)
 */
export function postCommWebApiOrganizationList(
  params: model.commWebApi.IPostCommWebApiOrganizationListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiOrganizationListResponse>('/commWebApi/organization/list', {
    data: pick(params, ['onlyHomeShow']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1505077, catid=256763, projectId=41427, created=2025-01-16 15:53:02, last-modified=2025-01-16 16:04:24
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/update)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1505077)
 */
export function postCommWebApiUserUpdate(params: model.commWebApi.IPostCommWebApiUserUpdateParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiUserUpdateResponse>('/commWebApi/user/update', {
    data: pick(params, ['newName', 'organization', 'sex', 'age', 'education', 'major', 'job', 'userType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1505069, catid=256763, projectId=41427, created=2025-01-16 15:50:55, last-modified=2025-06-25 15:27:47
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/me)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1505069)
 */
export function postCommWebApiUserMe(params: model.commWebApi.IPostCommWebApiUserMeParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiUserMeResponse>('/commWebApi/user/me', {
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1519180, catid=258057, projectId=41427, created=2025-04-25 14:04:02, last-modified=2025-04-27 14:36:00
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/model/translation)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1519180)
 */
export function postCommWebApiModelTranslation(
  params: model.commWebApi.IPostCommWebApiModelTranslationParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiModelTranslationResponse>('/commWebApi/model/translation', {
    data: pick(params, ['textList']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1524082, catid=258556, projectId=41427, created=2025-06-19 17:03:19, last-modified=2025-06-20 17:20:21
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/scholarship/save)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1524082)
 */
export function postCommWebApiScholarshipSave(
  params: model.commWebApi.IPostCommWebApiScholarshipSaveParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiScholarshipSaveResponse>('/commWebApi/scholarship/save', {
    data: pick(params, ['email', 'institution', 'laboratory', 'paperLink', 'saveType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1524245, catid=258556, projectId=41427, created=2025-06-23 14:09:38, last-modified=2025-06-23 14:26:16
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/scholarship/winner/all)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1524245)
 */
export function postCommWebApiScholarshipWinnerAll(
  params: model.commWebApi.IPostCommWebApiScholarshipWinnerAllParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiScholarshipWinnerAllResponse>('/commWebApi/scholarship/winner/all', {
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1523991, catid=258556, projectId=41427, created=2025-06-19 14:35:23, last-modified=2025-06-20 14:42:45
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/scholarship/recommend/queryToken)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1523991)
 */
export function postCommWebApiScholarshipRecommendQueryToken(
  params: model.commWebApi.IPostCommWebApiScholarshipRecommendQueryTokenParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiScholarshipRecommendQueryTokenResponse>('/commWebApi/scholarship/recommend/queryToken', {
    data: pick(params, ['token']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1523331, catid=258556, projectId=41427, created=2025-06-19 11:23:24, last-modified=2025-06-20 14:42:55
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/scholarship/recommend/generateToken)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1523331)
 */
export function postCommWebApiScholarshipRecommendGenerateToken(
  params: model.commWebApi.IPostCommWebApiScholarshipRecommendGenerateTokenParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiScholarshipRecommendGenerateTokenResponse>(
    '/commWebApi/scholarship/recommend/generateToken',
    {
      data: params,
      ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
    }
  );
}

/**
 * @desc id=1524016, catid=258556, projectId=41427, created=2025-06-19 16:09:12, last-modified=2025-06-20 14:42:16
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/scholarship/recommend/save)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1524016)
 */
export function postCommWebApiScholarshipRecommendSave(
  params: model.commWebApi.IPostCommWebApiScholarshipRecommendSaveParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiScholarshipRecommendSaveResponse>('/commWebApi/scholarship/recommend/save', {
    data: pick(params, ['token', 'recommendeeName', 'reason']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1523975, catid=258556, projectId=41427, created=2025-06-19 11:32:26, last-modified=2025-06-20 11:29:58
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/scholarship/draft/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1523975)
 */
export function postCommWebApiScholarshipDraftDetail(
  params: model.commWebApi.IPostCommWebApiScholarshipDraftDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiScholarshipDraftDetailResponse>('/commWebApi/scholarship/draft/detail', {
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521246, catid=258203, projectId=41427, created=2025-05-26 02:14:32, last-modified=2025-06-27 10:46:43
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521246)
 */
export function postCommWebApiUserVerificationDetail(
  params: model.commWebApi.IPostCommWebApiUserVerificationDetailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationDetailResponse>('/commWebApi/user/verification/detail', {
    data: pick(params, ['verificationType']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521406, catid=258203, projectId=41427, created=2025-05-27 15:25:58, last-modified=2025-06-16 17:15:25
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/upload)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521406)
 */
export function postCommWebApiUserVerificationUpload(params: FormData, options?: FlowHttpRequestOptions) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationUploadResponse>('/commWebApi/user/verification/upload', {
    data: params,
    ...mixHeadersOptions(options, { 'Content-Type': 'multipart/form-data' }),
  });
}

/**
 * @desc id=1520960, catid=258203, projectId=41427, created=2025-05-21 01:05:08, last-modified=2025-05-22 11:09:13
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/notification/readAll)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520960)
 */
export function postCommWebApiNotificationReadAll(
  params: model.commWebApi.IPostCommWebApiNotificationReadAllParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiNotificationReadAllResponse>('/commWebApi/notification/readAll', {
    params: pick(params, ['userId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/x-www-form-urlencoded' }),
  });
}

/**
 * @desc 成功返回
 *json
 *
 *
 *{
 *&#34;code&#34;: 0,
 *&#34;msg&#34;: &#34;success&#34;,
 *&#34;data&#34;: 12345
 *}
 *
 *
 *
 *
 *字段名
 *类型
 *说明
 *
 *
 *
 *
 *code
 *int
 *0表示成功
 *
 *
 *msg
 *String
 *提示信息
 *
 *
 *data
 *Long
 *认证ID
 *
 *
 *
 *失败返回
 *json
 *
 *
 *{
 *&#34;code&#34;: 1,
 *&#34;msg&#34;: &#34;提交认证材料失败，请稍后重试&#34;,
 *&#34;data&#34;: null
 *}
 *
 *4. 业务说明
 *
 *认证类型不同，必填项不同，具体校验见后端实现。
 *提交后会覆盖原有认证材料。
 *材料表会先删除原有，再批量插入新材料。
 *提交成功后返回认证ID。
 * @desc id=1521239, catid=258203, projectId=41427, created=2025-05-26 02:04:48, last-modified=2025-05-27 18:21:56
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/material/submit)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521239)
 */
export function postCommWebApiUserVerificationMaterialSubmit(
  params: model.commWebApi.IPostCommWebApiUserVerificationMaterialSubmitParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationMaterialSubmitResponse>(
    '/commWebApi/user/verification/material/submit',
    {
      data: pick(params, [
        'verificationId',
        'userId',
        'verificationType',
        'educationInfo',
        'workInfo',
        'abilityInfo',
        'expertInfo',
        'institutionInfo',
      ]),
      ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
    }
  );
}

/**
 * @desc 返回值
 *
 *
 *
 *字段名
 *类型
 *描述
 *
 *
 *
 *
 *id
 *Long
 *认证记录的主键 ID
 *
 *
 *
 *返回示例
 *成功返回：
 *json
 *
 *
 *
 *Apply{
 *&#34;success&#34;: true,
 *&#34;data&#34;: 12345,
 *&#34;message&#34;: null
 *}
 *
 *失败返回：
 *json
 *
 *
 *
 *Apply{
 *&#34;success&#34;: false,
 *&#34;data&#34;: null,
 *&#34;message&#34;: &#34;实名认证未通过，请核对信息后重新提交&#34;
 *}
 * @desc id=1520285, catid=258203, projectId=41427, created=2025-05-13 14:43:09, last-modified=2025-06-17 13:13:04
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/submit)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520285)
 */
export function postCommWebApiUserVerificationSubmit(
  params: model.commWebApi.IPostCommWebApiUserVerificationSubmitParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationSubmitResponse>('/commWebApi/user/verification/submit', {
    data: pick(params, ['userId', 'realName', 'idCardNo']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1523216, catid=258203, projectId=41427, created=2025-06-17 14:17:23, last-modified=2025-06-17 16:18:10
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/notification/hasUnreadNotifications)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1523216)
 */
export function postCommWebApiNotificationHasUnreadNotifications(
  params: model.commWebApi.IPostCommWebApiNotificationHasUnreadNotificationsParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiNotificationHasUnreadNotificationsResponse>(
    '/commWebApi/notification/hasUnreadNotifications',
    {
      data: params,
      ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
    }
  );
}

/**
 * @desc id=1520596, catid=258203, projectId=41427, created=2025-05-15 19:35:31, last-modified=2025-06-18 14:15:32
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/sendWorkEmail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520596)
 */
export function postCommWebApiUserVerificationSendWorkEmail(
  params: model.commWebApi.IPostCommWebApiUserVerificationSendWorkEmailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationSendWorkEmailResponse>('/commWebApi/user/verification/sendWorkEmail', {
    data: pick(params, ['workEmail']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520915, catid=258203, projectId=41427, created=2025-05-21 00:49:00, last-modified=2025-06-24 15:14:40
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/notification/getNotificationList)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520915)
 */
export function postCommWebApiNotificationGetNotificationList(
  params: model.commWebApi.IPostCommWebApiNotificationGetNotificationListParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiNotificationGetNotificationListResponse>(
    '/commWebApi/notification/getNotificationList',
    {
      params: pick(params, ['userId']),
      data: pick(params, ['module']),
      ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
    }
  );
}

/**
 * @desc id=1520951, catid=258203, projectId=41427, created=2025-05-21 01:04:41, last-modified=2025-05-21 01:14:03
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/notification/read)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520951)
 */
export function postCommWebApiNotificationRead(
  params: model.commWebApi.IPostCommWebApiNotificationReadParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiNotificationReadResponse>('/commWebApi/notification/read', {
    data: pick(params, ['notificationId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1521149, catid=258203, projectId=41427, created=2025-05-22 22:18:15, last-modified=2025-06-15 19:55:14
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/getDetails)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521149)
 */
export function postCommWebApiUserVerificationGetDetails(
  params: model.commWebApi.IPostCommWebApiUserVerificationGetDetailsParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationGetDetailsResponse>('/commWebApi/user/verification/getDetails', {
    data: pick(params, ['userId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520253, catid=258203, projectId=41427, created=2025-05-13 11:12:23, last-modified=2025-06-14 16:47:48
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/getStatus)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520253)
 */
export function postCommWebApiUserVerificationGetStatus(
  params: model.commWebApi.IPostCommWebApiUserVerificationGetStatusParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationGetStatusResponse>('/commWebApi/user/verification/getStatus', {
    params: pick(params, ['userId']),
    data: pick(params, ['userId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520604, catid=258203, projectId=41427, created=2025-05-15 19:42:31, last-modified=2025-06-18 15:02:24
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/verifyEmail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520604)
 */
export function postCommWebApiUserVerificationVerifyEmail(
  params: model.commWebApi.IPostCommWebApiUserVerificationVerifyEmailParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationVerifyEmailResponse>('/commWebApi/user/verification/verifyEmail', {
    params: pick(params, ['token']),
    data: pick(params, ['code', 'workEmail']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc 返回值
 *
 *
 *
 *字段名
 *类型
 *描述
 *
 *
 *
 *
 *id
 *Long
 *修改后的认证记录主键 ID返回示例
 *
 *
 *
 *成功返回
 *json
 *
 *
 *{
 *&#34;code&#34;: 0,
 *&#34;msg&#34;: &#34;success&#34;,
 *&#34;data&#34;: 12345
 *}
 *
 *
 *
 *
 *字段名
 *类型
 *说明
 *
 *
 *
 *
 *code
 *int
 *0表示成功
 *
 *
 *msg
 *String
 *提示信息
 *
 *
 *data
 *Long
 *认证ID
 *
 *
 *
 *失败返回
 *json
 *
 *
 *{
 *&#34;code&#34;: 1,
 *&#34;msg&#34;: &#34;修改认证信息失败，请稍后重试&#34;,
 *&#34;data&#34;: null
 *}
 *
 *4. 业务说明
 *
 *认证类型不同，必填项不同，具体校验见后端实现。
 *修改后会覆盖原有认证信息和材料。
 *认证材料会先删除原有，再批量插入新材料。
 *修改成功后返回认证ID。
 * @desc id=1521158, catid=258203, projectId=41427, created=2025-05-22 22:23:33, last-modified=2025-06-16 11:14:02
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/commWebApi/user/verification/modify)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1521158)
 */
export function postCommWebApiUserVerificationModify(
  params: model.commWebApi.IPostCommWebApiUserVerificationModifyParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.commWebApi.IPostCommWebApiUserVerificationModifyResponse>('/commWebApi/user/verification/modify', {
    data: pick(params, [
      'verificationId',
      'userId',
      'verificationType',
      'materialType',
      'educationInfo',
      'workInfo',
      'abilityInfo',
      'expertInfo',
      'institutionInfo',
    ]),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}
